<script setup>
import { ref } from 'vue';
import Commons from '../../shared/libraries/commons';
const matchData = ref(null);
</script>

<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.MATCH.SHOW_MATCH_DETAIL"
    :handler="
      (data) => {
        matchData = data;
        $refs.dialog.show();
      }
    "
  />
  <DialogComponent
    ref="dialog"
    type="fullscreen"
    hideCloseButton
    noInnerPadding
  >
    <div
      class="h-full pb-[5vh] overflow-auto w-full top-0 left-0 pt-24"
      v-if="matchData"
    >
      <div class="mobile-status-padding"></div>

      <div class="bg-primary w-full fixed top-0 z-2">
        <div class="mobile-status-padding"></div>
        <div class="px-4 overflow-x-hidden w-full h-24">
          <div class="flex gap-4 items-center h-full">
            <div class="w-8 h-8 min-w-8 flex items-center justify-center">
              <button class="w-full h-full" @click="$refs.dialog.hide()">
                <ColorImg
                  src="/images/icons/arrow-up.svg"
                  class="w-full h-full bg-white -rotate-90 opacity-70"
                  alt="Calendar"
                />
              </button>
            </div>
            <div class="w-full overflow-hidden">
              <div
                class="text-white truncate w-full text-center text-2xl font-bold"
              >
                {{ Commons.time(matchData?.date, 'dddd, D MMM YYYY') }}
              </div>
              <div
                class="text-white/80 truncate w-full text-center text-2xl uppercase font-bold"
              >
                {{ matchData?.time || '-' }}
              </div>
            </div>
            <div class="w-8 h-8 min-w-8 flex items-center justify-center"></div>
          </div>
        </div>
      </div>
      <div class="bg-primary">
        <div class="grid grid-cols-3 p-5 items-center">
          <div class="flex flex-col items-center justify-center gap-2">
            <div class="w-2/3 p-5 bg-white/40 rounded-full">
              <div class="w-full py-[50%] relative">
                <ImgComponent
                  :src="matchData?.team1?.logo"
                  fallback="/images/match/t-shirt.svg"
                  class="w-full h-full rounded-full absolute top-0 left-0"
                  alt=""
                />
              </div>
            </div>
            <div
              class="text-lg text-white line-clamp-2 text-center font-bold h-[2lh]"
            >
              {{ matchData?.team1?.name }}
            </div>
          </div>
          <div class="flex items-center flex-col text-5xl">
            <div
              class="grid grid-cols-3 items-center gap-2 font-bold text-ceter"
            >
              <div class="text-white">
                {{ matchData?.team1?.score ?? '' }}
              </div>
              <div class="text-white/60">-</div>
              <div class="text-white">
                {{ matchData?.team2?.score ?? '' }}
              </div>
            </div>
            <div class="h-[1lh]"></div>
          </div>
          <div class="flex flex-col items-center justify-center gap-2">
            <div class="w-2/3 p-5 bg-white/40 rounded-full">
              <div class="w-full py-[50%] relative">
                <ImgComponent
                  :src="matchData?.team2?.logo"
                  fallback="/images/match/t-shirt.svg"
                  class="w-full h-full rounded-full absolute top-0 left-0"
                  alt=""
                />
              </div>
            </div>
            <div
              class="text-lg text-white line-clamp-2 text-center font-bold h-[2lh]"
            >
              {{ matchData?.team2?.name }}
            </div>
          </div>
        </div>
      </div>

      <!-- Match Information Section -->
      <div class="p-8 space-y-8">
        <!-- Location and Duration Info -->
        <div
          v-if="matchData?.location || matchData?.durationMin"
          class="space-y-4"
        >
          <div class="text-xl text-primary-900 font-bold mb-2">
            Informations du match
          </div>
          <div class="p-4 bg-white flex flex-col gap-4">
            <div v-if="matchData?.location" class="space-y-2">
              <div class="font-medium text-primary-700">Lieu</div>
              <div class="text-primary-900">
                <div v-if="matchData.location.country">
                  {{ matchData.location.country }}
                </div>
                <div v-if="matchData.location.city">
                  {{ matchData.location.city }}
                </div>
              </div>
            </div>
            <div v-if="matchData?.durationMin !== undefined" class="space-y-2">
              <div class="font-medium text-primary-700">Durée</div>
              <div class="text-primary-900">
                {{ matchData.durationMin }} minutes
              </div>
            </div>
            <div v-if="matchData?.league" class="space-y-2">
              <div class="font-medium text-primary-700">Compétition</div>
              <div class="text-primary-900">{{ matchData.league }}</div>
            </div>
          </div>
        </div>

        <!-- Basic Quotes Section -->
        <!-- <div class="space-y-4">
          <div class="text-xl text-primary-900 font-bold mb-2">
            Côtes principales
          </div>
          <div class="p-4 bg-white flex flex-col gap-5">
            <div
              v-for="quoteId in [
                { name: `Victoire de ${matchData?.team1?.name}`, id: '1' },
                { name: 'Match nul', id: 'X' },
                { name: `Victoire de ${matchData?.team2?.name}`, id: '2' }
              ]"
              :key="quoteId.name"
              class="flex items-center justify-between p-2 rounded-lg bg-gray-50"
            >
              <div class="font-medium text-primary-700 truncate">
                {{ quoteId.name }}
              </div>
              <div class="font-bold text-lg text-primary-900">
                {{ (matchData.quotes && matchData.quotes[quoteId.id]) || '-' }}
              </div>
            </div>
          </div>
        </div> -->

        <!-- All Detailed Odds Section -->
        <!-- <div
          v-if="matchData?.allOdds && Object.keys(matchData.allOdds).length > 0"
          class="space-y-4"
        >
          <div class="text-xl text-primary-900 font-bold mb-2">
            Toutes les côtes disponibles
          </div>
          <div class="p-4 bg-white">
            <div class="space-y-2">
              <div
                v-for="(odd, type) in matchData.allOdds"
                :key="type"
                v-show="!/inconnu/i.test(odd.description)"
                class="flex flex-col sm:flex-row sm:items-center justify-between p-3 rounded-lg bg-gray-50 gap-2"
              >
                <div class="flex-1">
                  <div class="font-medium text-primary-900">
                    {{ odd.description }}
                  </div>
                  <div class="text-xs text-primary-600">
                    Type: {{ type }} | Groupe: {{ odd.group }}
                  </div>
                </div>
                <div class="flex items-center gap-4">
                  <div class="text-right">
                    <div class="font-bold text-lg text-primary-900">
                      {{ odd.value }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </DialogComponent>
</template>
